import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "/src/assets/styles/style.css";
import "/src/assets/styles/utilities.css";
import "/src/assets/styles/custom.css";
import locale from 'element-ui/lib/locale/lang/en'
import VueVideoPlayer from "vue-video-player";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import "video.js/dist/video-js.css";
import App from "./App.vue";
import router from './router';
import { checkSession } from '/src/assets/js/helpers';

// ✅ Call it before app mounts
checkSession();

Vue.use(
  VueVideoPlayer /* {
  options: global default options,
  events: global videojs events
} */
);

let base = window.location.origin.replace(/^https?:\/\//, '');

const env = process.env.VUE_APP_ENV
if(env === 'local') {
  base = 'localhost'
} else {
  const hostnameParts = window.location.hostname.split('.');
  const root_domain = hostnameParts.reverse()
  base = '.' + root_domain[1] + '.' + root_domain[0]
}
console.log(base,'base')

Vue.use(VueCookies, { expires: '1h', path: '/', domain: base, secure: 'true', sameSite: 'Lax' , partitioned: false}
 )
Vue.use(ElementUI, { locale });
Vue.use(VueAxios, axios)
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
